import React from 'react';
import { Buttons, Coin } from '../../component';
import useStyles from './styles';

const ButtonTakeAssessment = ({
    onClick,
    text,
    coin,
    takeAssement,
}) => {
    const classes = useStyles()
    return (
        <div
            className={classes.btnTAContainer}
        >
            <Buttons
                text={text}
                onClick={onClick}
                customClass={"btnTakeAssessment"}
            />
            {takeAssement &&
                <Coin
                    coin={coin}
                    takeAssessment={true}
                    size="small"
                />
            }
        </div>
    )
}

export default ButtonTakeAssessment